import React from 'react';

const TenantReportsPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/manager/reports',
			exact: false,
			component: React.lazy(() => import('./TenantReportsPage')),
		},
	],
};

export default TenantReportsPageConfig;
